import React, { useState } from "react";
import { createClient } from "@supabase/supabase-js";
import { Button, Spinner } from "react-bootstrap";

const { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } = process.env;
const supabase = createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY);

const BotonExportarCSV = ({ filtroFecha }) => {
    const [exportando, setExportando] = useState(false);

    const descargarCSV = async () => {
        setExportando(true);
        try {
            // Buscamos todas las citas de clientes reales (excluyendo bloqueos ficticios)
            let query = supabase
                .from("citas")
                .select("*")
                .neq("tipo_de_masaje", "Bloqueado")
                .order("hora", { ascending: false });

            // Si el administrador tiene un filtro de día seleccionado, lo aplicamos a la descarga
            if (filtroFecha) {
                const desde = new Date(filtroFecha); desde.setHours(0, 0, 0, 0);
                const hasta = new Date(filtroFecha); hasta.setHours(23, 59, 59, 999);
                query = query.gte("hora", desde.toISOString()).lte("hora", hasta.toISOString());
            }

            const { data, error } = await query;

            if (error) throw error;
            if (!data || data.length === 0) {
                alert("No hay registros disponibles para exportar en este criterio.");
                setExportando(false);
                return;
            }

            // 1. Definimos los títulos de las columnas del Excel
            const cabeceras = ["Fecha", "Hora", "Cliente", "Teléfono", "Email", "Tipo Masaje", "Duración", "Confirmada", "Pagada", "Comentario"];
            
            // 2. Mapeamos los registros al formato fila por fila separados por comas
            const filas = data.map(cita => {
                const fechaObj = new Date(cita.hora);
                const fecha = fechaObj.toLocaleDateString();
                const hora = fechaObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                const nombreCompleto = `${cita.nombre} ${cita.primer_apellido || ""} ${cita.segundo_apellido || ""}`.trim();
                
                // Función higiénica para evitar que las comas o comillas del usuario rompan las columnas del CSV
                const escapar = (texto) => {
                    if (!texto) return '""';
                    const cadenaLimpia = String(texto).replace(/"/g, '""'); // Duplica comillas internas
                    return `"${cadenaLimpia}"`;
                };

                return [
                    escapar(fecha),
                    escapar(hora),
                    escapar(nombreCompleto),
                    escapar(cita.telefono),
                    escapar(cita.email),
                    escapar(cita.tipo_de_masaje),
                    escapar(`${cita.duracion} min`),
                    escapar(cita.confirmada ? "SÍ" : "NO"),
                    escapar(cita.ha_pagado ? "SÍ" : "NO"),
                    escapar(cita.comentario_cliente)
                ].join(",");
            });

            // 3. Montamos el string final sumando el BOM (\uFEFF) para forzar lectura UTF-8 en Excel España
            const contenidoCSV = "\uFEFF" + [cabeceras.join(","), ...filas].join("\n");
            
            // 4. Creamos un link fantasma en el navegador para iniciar la descarga automáticamente
            const blob = new Blob([contenidoCSV], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            
            const nombreArchivo = filtroFecha 
                ? `agenda_${new Date(filtroFecha).toISOString().slice(0, 10)}.csv`
                : "agenda_completa_clientes.csv";

            link.setAttribute("href", url);
            link.setAttribute("download", nombreArchivo);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (err) {
            alert("Error al generar el reporte: " + err.message);
        } finally {
            setExportando(false);
        }
    };

    return (
        <Button 
            variant="outline-success" 
            onClick={descargarCSV} 
            disabled={exportando}
            style={{ fontWeight: "500", display: "inline-flex", alignItems: "center", gap: "8px" }}
        >
            {exportando ? (
                <>
                    <Spinner animation="border" size="sm" role="status" />
                    Procesando Agenda...
                </>
            ) : (
                <>Exportar Excel (.CSV)</>
            )}
        </Button>
    );
};

export default BotonExportarCSV;